import { Link } from 'react-router-dom'
import { useMarketContext } from '@/feed/useMarketContext'
import { useAuth } from '@/store/auth'

export function SimulationBanner() {
  const market = useMarketContext()
  const owner = useAuth((s) => s.user?.role === 'OWNER')
  if (market.source !== 'SIMULATION') return null
  return (
    <div role="status" className="flex shrink-0 items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs text-amber-600 dark:text-amber-400">
      <span><strong>NIFTY simulation · {market.status.toLowerCase()}</strong> — Synthetic prices and OI. Orders on every selected account fill locally. Other underlyings are unavailable.</span>
      {owner ? <Link to="/simulation" className="shrink-0 underline">Session controls</Link> : null}
    </div>
  )
}
